export function StatusDot({ online }) {
  return (
    <span
      className={`inline-block h-2 w-2 rounded-full ${
        online ? "bg-emerald-500 status-ping" : "bg-zinc-300"
      }`}
    />
  );
}

export function StatusBadge({ status }) {
  const map = {
    registered: ["bg-emerald-50 text-emerald-700 border-emerald-200", "Enregistré"],
    online: ["bg-emerald-50 text-emerald-700 border-emerald-200", "En ligne"],
    active: ["bg-emerald-50 text-emerald-700 border-emerald-200", "Actif"],
    configured: ["bg-blue-50 text-blue-700 border-blue-200", "Configuré"],
    pending: ["bg-amber-50 text-amber-700 border-amber-200", "À déployer"],
    offline: ["bg-zinc-100 text-zinc-500 border-zinc-200", "Hors ligne"],
    none: ["bg-amber-50 text-amber-700 border-amber-200", "Non configuré"],
  };
  const [cls, label] = map[status] || map.offline;
  return (
    <span
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[11px] font-medium ${cls}`}
    >
      {label}
    </span>
  );
}
